import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import { StrainMeasurementGageValuesModel } from '@app/strain/common/models/view-measurement-models/strain-measurement-gage-values.model';
import { AppUtils } from '@app/shared/util/app.utils';

export interface StrainMeasurementExcelParseResult {
    gageValues: StrainMeasurementGageValuesModel[];
    chartBase64: string;
}

export interface ParsedMeasurementUploadResult {
    gageValues: StrainMeasurementGageValuesModel[];
    chartFile: File | null;
}

@Injectable()
export class MeasurementExcelImportService {
    private static readonly API_MEASUREMENTS_BASE_PATH = `${environment.baseURL}/api/strain/measurement-results`;

    constructor(private http: HttpClient) {
    }

    parseMeasurementExcel(file: File) {
        const formData = new FormData();
        formData.append('file', file);

        return this.http.post<StrainMeasurementExcelParseResult>(
            `${MeasurementExcelImportService.API_MEASUREMENTS_BASE_PATH}/parse-excel`,
            formData
        ).pipe(
            map(result => this.mapResult(result, file.name))
        );
    }

    private mapResult(result: StrainMeasurementExcelParseResult, originalName: string): ParsedMeasurementUploadResult {
        const chartFile = this.buildChartFile(result.chartBase64, originalName);
        const gageValues = (result.gageValues || []).map(entry => new StrainMeasurementGageValuesModel(entry));
        return {
            gageValues,
            chartFile
        };
    }

    private buildChartFile(chartBase64: string, originalName: string): File | null {
        if (!chartBase64) {
            return null;
        }

        const dataUri = `data:image/png;base64,${chartBase64}`;
        const blob = AppUtils.dataURItoBlob(dataUri);
        const baseName = originalName ? originalName.replace(/\.[^/.]+$/, '') : 'measurement';
        const file: any = new File([blob], `${baseName}-chart.png`, { type: 'image/png' });
        file.objectUrl = URL.createObjectURL(file);
        file.url = file.objectUrl;
        return file;
    }
}
